import React from 'react'
import Link from 'next/link'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

interface AccountBreadcrumbProps {
  homeLink: string
  beforeLink: string
  secondLabel: string
  thirdLabel: string
}

const AccountBreadcrumb: React.FC<AccountBreadcrumbProps> = (props) => {

  return <Breadcrumb>
    <Link href={props.homeLink} passHref style={{ paddingInline: '0.5rem' }}>
      <Breadcrumb.Item>
        <HomeOutlined />
      </Breadcrumb.Item>
    </Link>
    <Link href={props.beforeLink} passHref style={{ paddingInline: '0.5rem' }}>
      <Breadcrumb.Item>
        <span>{props.secondLabel}</span>
      </Breadcrumb.Item>
    </Link>
    <Breadcrumb.Item>{props.thirdLabel}</Breadcrumb.Item>
  </Breadcrumb>
}

export default AccountBreadcrumb
